import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import AppBar from '../../commons/AppBar'
import Utils from '../../providers/Utils';
import { Button, LinearProgress } from '@material-ui/core';
import Ws from '../../providers/Ws';
import FromServer from './FromServer';


export default class Mesagerie extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        progressBar:'none',
        disableButton:false,
        listLog:[]
}
    }

     componentDidMount(){
    }

    getLogMesaj = async() =>{






        this.setState({
            disableButton:true,
            progressBar:'block'
        },async()=>{
           
            let fs = new FromServer();

            let messagerie =await fs.getMesagerie()

            if(messagerie.r){
                this.setState({listLog:messagerie.c,
                    disableButton:false,
                    progressBar:'none'})
            }

                  

                
        })

        
                                    

    }
    
     render() { 
       return (
          <div>
              <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.mesagerie} />
              <div
              style={{
                  maxWidth:960,
                  width:'95%',
                  margin:'auto',
                  marginTop:50,
                  border:'1px solid #d8d3d3',
                  marginBottom:50

              }}>
                  <h5 
                  style={{
                      color:'rgba(11, 145, 179, 0.87)',
                      fontWeight:600,
                      width:'fit-content',
                      margin:'10px auto 10px auto',
                      textDecoration:'underline'

                  }}
                  className='pm-title'>{this.dictionary.mesagerie.trimiteUtilizatori}</h5>
                  <div style={{textAlign:'left',
                    paddingLeft:50,
                    color: '#7d7d7d',
                    paddingRight:50}}>
                    <span>{new Utils().dataFull()}</span>
                    <Button
                    disabled={this.state.disableButton}
                        style={{
                            display:'inline-block',
                            float:'right',
                            marginBottom:20,
                            backgroundColor:'#22c2ff',
                            color:'white'

                        }}
                    variant="contained" onClick={this.getLogMesaj} >
                                   {this.dictionary.mesagerie.trimiteSumar}
                          </Button>
                  </div>
                  <div style={{clear:'both'}}>

                  </div>
                  
                  <LinearProgress
                  classes={{bar : 'progressbar'}}
                   style={{display:this.state.progressBar}} 
                  size={30} thickness={8} />

            {this.state.listLog.length > 0 &&
                  <ul style={{listStyleType:'none',
                            textAlign:'right',
                            padding:30,
                            fontSize:15 }}>
                {this.state.listLog.map((l,idx)=>{
                    return(
                        <li
                        style={{
                            lineHeight:2
                        }}
                        key={idx} style={{color:l.status === 'err' ? 'red' : 'green'}}>
                            {l.msg}
                        </li>
                    )
                })}
              </ul>
            }
              </div>
              
         </div>
        );
       }
}